import { render, staticRenderFns } from "./PlanComponent.vue?vue&type=template&id=2ae22cfe"
import script from "./PlanComponent.vue?vue&type=script&lang=js"
export * from "./PlanComponent.vue?vue&type=script&lang=js"
import style0 from "./PlanComponent.vue?vue&type=style&index=0&id=2ae22cfe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports